import * as React from 'react';

import {Text, TokenTextAppearance} from '@volkswagen-onehub/components-core';
import {StyledAccessibleLabel} from '../helpers';
import {VideoElementLabels} from '../../../../generated/core';

export interface VideoPlayerTimeProps
    extends Pick<VideoElementLabels, 'remainingTimeLabel'> {
    readonly timeInSeconds?: number;
}

const TIME_PLACEHOLDER = '--:--';
const SECONDS_IN_MINUTE = 60;

const formatSeconds = (seconds: number) =>
    seconds < 10 ? `0${seconds.toFixed(0)}` : seconds.toFixed(0);

const formatMinutes = (minutes: number) => minutes.toFixed(0);

export const formatTime = (timeInSeconds: number) => {
    const minutes = Math.floor(timeInSeconds / SECONDS_IN_MINUTE);
    const seconds = Math.round(timeInSeconds % SECONDS_IN_MINUTE);

    return `${formatMinutes(minutes)}:${formatSeconds(seconds)}`;
};

export const VideoPlayerTime: React.FunctionComponent<
    VideoPlayerTimeProps
> = props => {
    const {timeInSeconds, remainingTimeLabel} = props;

    const time =
        timeInSeconds === undefined
            ? TIME_PLACEHOLDER
            : formatTime(timeInSeconds);

    /* we need to remove the colon : from the time
    otherwise screenreaders announce the time as daytime in certain languages */
    const screenReaderTime =
        timeInSeconds === undefined
            ? TIME_PLACEHOLDER
            : formatTime(timeInSeconds).replace(/:/g, ' ');

    return (
        <>
            {/* aria-hidden applies to children too*/}
            <div aria-hidden="true">
                <Text appearance={TokenTextAppearance.copy100}>{time}</Text>
            </div>
            <StyledAccessibleLabel>
                {remainingTimeLabel + ', ' + screenReaderTime}
            </StyledAccessibleLabel>
        </>
    );
};
